import { loginUsername, logout as logoutApi } from "@/api/login";
import { getUserInfo } from "@/api/user";
import { encryption } from "@/utils/utils";
import { defineStore } from "pinia";
import { ref } from "vue";
// state
const token = ref("");
const nickname = ref("");
const avatar = ref("");
const roles = ref([]); // 用户角色编码集合 → 判断路由权限
const perms = ref(); // 用户权限编码集合 → 判断按钮权限
const accessToken = ref("");
const refreshToken = ref("");
const topMenuList = ref([]); // 顶部菜单
const allMenuList = ref([]); // 所有菜单
const sysUser = ref(); //用户信息
const roleCodes = ref([]);
const tenantId = ref("");
const tenantCode = ref("");
const tenantName = ref(null);
const tenantResources = ref([]);
const companyCode = ref("");
const companyName = ref("");
const userId = ref(null);
// 登录
async function loginByUsername(loginData, tenant) {
  try {
    let res = {};
    // 密码登录
    if (loginData.grant_type == "password") {
      loginData = encryption({
        data: loginData,
        key: "shzbshzbshzbshzb",
        param: ["password"]
      });
      res = await loginUsername(loginData, tenant.id, tenant.code);
    } else if (loginData.grant_type) {
      res = await loginUsername(loginData, tenant.id, tenant.code);
    }
    if (!res.access_token) return;
    tenantId.value = tenant.id;
    tenantCode.value = tenant.code;
    accessToken.value = res["access_token"] || "";
    refreshToken.value = res["refresh_token"] || "";
    token.value = "Bearer " + res["access_token"] || "";
    // await wait(40)
    // 获取用户所需信息
    await getUserBaseInfo();
  } catch (e) {
    throw new Error(e);
  }
}
/**
 * 获取用户信息(用户昵称、头像、角色集合),顶部菜单、所有菜单
 * @returns
 */
async function getUserBaseInfo() {
  // 获取用户信息和菜单列表
  const [userInfoData] = await Promise.all([getUserInfo()]);
  userId.value = userInfoData.sysUser.userId;
  perms.value = userInfoData.permissions || [];
  roles.value = userInfoData.roles || [];
  roleCodes.value = userInfoData.roleCodes || [];
  nickname.value = userInfoData.sysUser?.nickname || userInfoData.sysUser?.name || "用户";
  avatar.value = userInfoData.sysUser.avatar || "";
  sysUser.value = userInfoData.sysUser;
  tenantId.value = userInfoData.sysTenant.id;
  tenantCode.value = userInfoData.sysTenant.code;
  tenantName.value = userInfoData.sysTenant.name;
  companyCode.value = userInfoData.mainCompany?.deptCode || '';
  companyName.value = userInfoData.mainCompany?.name || '';
  tenantResources.value = userInfoData.sysTenant.resources;
  // console.log(userInfo, '== userInfo ==')
}
// 注销
function logout() {
  return new Promise((resolve, reject) => {
    logoutApi().then(() => {
      // resetRouter();
      resetToken();
      resolve();
    }).catch(error => {
      resetToken();
      resolve();
      reject(error);
    });
  });
}
// 重置
function resetToken() {
  tenantId.value = '';
  tenantCode.value = '';
  tenantName.value = '';
  token.value = "";
  nickname.value = "";
  avatar.value = "";
  roles.value = [];
  perms.value = [];
  topMenuList.value = [];
  allMenuList.value = [];
  sysUser.value = undefined;
  // 清除本地缓存数据
  window.localStorage.clear();
  window.sessionStorage.clear();
}
export default defineStore("user", () => ({
  token,
  userId,
  tenantId,
  tenantCode,
  tenantName,
  tenantResources,
  companyCode,
  companyName,
  roles,
  roleCodes,
  perms,
  nickname,
  avatar,
  sysUser,
  loginByUsername,
  getUserBaseInfo,
  logout,
  resetToken
}), {
  persist: {
    enabled: true,
    strategies: [{
      storage: window.localStorage,
      paths: ["token", "tenantId", "tenantCode"]
    }]
  }
});